import getCssVar from 'src/utils/getCssVar'
import { hexToObj } from 'src/utils/Color'
import COLORS from 'src/data/colors'

const getCssVarWithFallback = (name, fallback) => getCssVar(name) || fallback

const defaultFontFamily =
  'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", ' +
  '"Noto Sans", "Liberation Sans", Arial, sans-serif'

let cache

const stripeAppearance = () => {
  if (cache) return cache

  const primary = getCssVarWithFallback('--bs-primary', COLORS.primary)

  const primaryRgb = getCssVarWithFallback(
    '--bs-primary-rgb',
    Object.values(hexToObj(primary) || {}).join()
  )

  const danger = getCssVarWithFallback('--bs-danger', COLORS.danger)
  const dangerRgb = getCssVarWithFallback(
    '--bs-danger-rgb',
    Object.values(hexToObj(danger) || {}).join()
  )

  return cache = {
    variables: {
      borderRadius: getCssVarWithFallback('--bs-border-radius', '0.375rem'),
      colorPrimary: primary,
      colorText: getCssVarWithFallback('--bs-body-color', '#212529'),
      colorTextPlaceholder: getCssVarWithFallback('--bs-secondary-color', 'rgba(33, 37, 41, 0.75)'),
      colorDanger: danger,
      fontFamily: getCssVarWithFallback('--bs-body-font-family', defaultFontFamily),
      fontLineHeight: getCssVarWithFallback('--bs-body-line-height', '1.5'),
      fontWeightNormal: getCssVarWithFallback('--bs-body-font-weight', '400'),
      fontSmooth: 'never',
      spacingGridColumn: '0.5rem',
      spacingGridRow: '1rem',
    },
    rules: {
      '.Label': {
        marginBottom: 'var(--p-spacing2)',
        fontSize: 'var(--fontSizeBase)',
        lineHeight: 'var(--fontLineHeight)',
      },
      '.Error': {
        fontSize: 'var(--fontSizeXs)',
        lineHeight: 'var(--fontLineHeight)',
      },
      '.Input': {
        paddingTop: '0.375rem',
        paddingBottom: '0.375rem',
        borderColor: '#dee2e6',
        boxShadow: 'none',
        lineHeight: 'var(--fontLineHeight)',
      },
      '.Input:focus': {
        borderColor: getCssVarWithFallback(
          '--bs-input-focus-border-color',
          'var(--colorPrimary)'
        ),
        boxShadow: `0 0 0 0.25rem rgba(${primaryRgb}, 0.25)`,
      },
      '.Input--invalid': {
        boxShadow: 'none',
      },
      '.Input--invalid:focus': {
        borderColor: getCssVarWithFallback('--bs-form-invalid-border-color', danger),
        boxShadow: `0 0 0 0.25rem rgba(${dangerRgb}, 0.25)`,
      },
    },
  }
}

export default stripeAppearance
